export const BREAKPOINTS = {
  sm: '560px',
  lg: '1080px',
  xl: '1900px'
};

export const GUTTER = '20px';
